import React, { ReactElement, ReactNode } from 'react';
import { SelectProps } from '@material-ui/core/Select';
import { PasslyDropdown } from '@app/components';
import { TranslationsTypes } from '@app/models';
import { useTypedTranslation } from '@app/hooks';

interface IProps extends SelectProps {
    label?: TranslationsTypes | string;
    onChange?: (e: any) => void;
    value: any;
    options?: any;
    optionLabel?: string;
    optionValue?: string;
    errorMessage?: string;
    placeholder?: string;
    disabled?: boolean;
    showClear?: boolean;
    icon?: (item: any) => ReactNode;
    appendTo?: Element;
    itemTemplate?: (item: any) => ReactElement;
    valueTemplate?: (item: any) => ReactElement;
}

export const PasslySelect = (props: IProps) => {
    const { label, onChange, value, options, optionLabel = 'label', optionValue = 'value', placeholder, disabled, showClear, icon, itemTemplate, valueTemplate } = props;
    const { translation } = useTypedTranslation();

    const getItemTemplate = (item: any) => {
        return item && item[optionLabel] ? (<div className='dropdown__item-content'>{icon && icon(item)} {translation(item[optionLabel])}</div>) : <></>;
    };

    const getValueTemplate = (item: any) => {
        return item && item[optionLabel] ? (<div className='dropdown__item-content'>{icon && icon(item)} {translation(item[optionLabel])}</div>) : <>{placeholder}</>;
    };

    return (
        <PasslyDropdown
            className={`passlySelect ${props.className}`}
            options={options}
            itemTemplate={itemTemplate || getItemTemplate}
            valueTemplate={valueTemplate || getValueTemplate}
            onChange={onChange}
            optionLabel={optionLabel}
            optionValue={optionValue}
            disabled={disabled}
            placeholder={placeholder}
            showClear={showClear}
            {...props}
            label={translation((label ?? '') as TranslationsTypes)}
        />
    );
};
